import script from "./BatteryGraphs.vue?vue&type=script&setup=true&lang=js"
export * from "./BatteryGraphs.vue?vue&type=script&setup=true&lang=js"

import "./BatteryGraphs.vue?vue&type=style&index=0&id=1bda7364&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1bda7364"]])

export default __exports__